import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Select from 'antd/lib/select';
import { messageStatusT } from '../../../../common/enums';

const { Option } = Select;

const MessageStatus = ({ t, value, onChange }) => {
  return (
    <Select placeholder={t('Vybrať stav')} onChange={onChange} value={value}>
      <Option value="">{t('Všetky')}</Option>
      {Object.entries(messageStatusT).map(([key, value]) => (
        <Option key={key} value={key}>
          {value}
        </Option>
      ))}
    </Select>
  );
};

MessageStatus.propTypes = {
  t: PropTypes.func.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

MessageStatus.defaultProps = {
  value: '',
};

export default translate()(MessageStatus);



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/filters/MessageStatus.js